export enum ResetPasswordType {
    'None' = 0,
    'ByMail' = 1,
    'ByAdmin' = 2
}